import React, { useEffect, useState } from 'react';
import { Drawer, List, ListItem, ListItemIcon, ListItemText, Divider, Toolbar, Tooltip } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import FolderIcon from '@mui/icons-material/Folder';
import DescriptionIcon from '@mui/icons-material/Description';
import AssessmentIcon from '@mui/icons-material/Assessment';
import PeopleIcon from '@mui/icons-material/People';
import { useNavigate, useLocation } from 'react-router-dom';
import { ensureLogin, getCurrentUser } from '../utils/api';

const Sidebar = ({ open }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        await ensureLogin();
        const me = await getCurrentUser();
        if (mounted) setCurrentUser(me || null);
      } catch {
        // ignora falhas
      }
    })();
    return () => { mounted = false; };
  }, []);

  const menuItems = [
    { text: 'Dashboard', icon: <DashboardIcon />, path: '/' },
    { text: 'Projetos', icon: <FolderIcon />, path: '/projects' },
    { text: 'Avaliações', icon: <AssessmentIcon />, path: '/evaluations' },
    { text: 'Templates', icon: <DescriptionIcon />, path: '/templates' },
    // Equipa apenas visível para administradores
    ...(currentUser?.role === 'admin' ? [{ text: 'Equipa', icon: <PeopleIcon />, path: '/team' }] : []),
  ];

  return (
    <Drawer
      variant="persistent"
      open={open}
      sx={{
        width: open ? 220 : 60,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: open ? 220 : 60,
          boxSizing: 'border-box',
          position: 'relative',
        },
      }}
    >
      <Toolbar />
      <List>
        {menuItems.map((item) => (
          open ? (
            <ListItem 
              button 
              key={item.text} 
              onClick={() => navigate(item.path)}
              selected={location.pathname === item.path}
              sx={{
                '&.Mui-selected': {
                  backgroundColor: 'primary.light',
                  '&:hover': {
                    backgroundColor: 'primary.light',
                  },
                },
              }}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItem>
          ) : (
            <Tooltip title={item.text} placement="right" key={item.text}>
              <ListItem 
                button 
                onClick={() => navigate(item.path)}
                selected={location.pathname === item.path}
                sx={{
                  '&.Mui-selected': {
                    backgroundColor: 'primary.light',
                    '&:hover': {
                      backgroundColor: 'primary.light',
                    },
                  },
                }}
              >
                <ListItemIcon sx={{ minWidth: 0, justifyContent: 'center' }}>{item.icon}</ListItemIcon>
              </ListItem>
            </Tooltip>
          )
        ))}
      </List>
    </Drawer>
  );
};

export default Sidebar;